import { Component, OnDestroy, ChangeDetectionStrategy, OnInit, ChangeDetectorRef, AfterViewInit } from '@angular/core';
import { deleteJsonLd, ObservableCacheDecorator } from '@box/utils';
import {
  APIResponse,
  CookiesConsentTableColumnsTitle,
  CookiesConsentTableData,
  CookiesConsentTableInfo,
  SeoOptions
} from '@box-types';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfigurationService, SentryService, SEOService } from '@box-core/services';
import { HttpClient } from '@angular/common/http';
import { catchError, finalize, map } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Component({
  selector: 'account-cookies',
  templateUrl: './account-cookies.page.html',
  styleUrls: ['./account-cookies.page.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AccountCookiesPage implements OnInit, AfterViewInit, OnDestroy {
  public loading: boolean;
  public columnsTitles: CookiesConsentTableColumnsTitle[];
  public tableInfo: CookiesConsentTableInfo[];

  constructor(
    private activatedRoute: ActivatedRoute,
    private seoService: SEOService,
    private router: Router,
    private http: HttpClient,
    private configurationService: ConfigurationService,
    private sentryService: SentryService,
    private changeDetectorRef: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.setMetaTags();
  }

  ngAfterViewInit(): void {
    this.getCookiesTableData();
  }

  ngOnDestroy(): void {
    deleteJsonLd();
  }

  private getCookiesConsentTableUrl(): string {
    const data = this.configurationService.getConfiguration().cookiesConsentTable;
    return data as string;
  }

  private getCookiesTableData(): void {
    this.loading = true;
    this.changeDetectorRef.detectChanges();
    this.fetchCookiesTableData()
      .pipe(
        finalize(() => {
          this.loading = false;
          this.changeDetectorRef.detectChanges();
        })
      )
      .subscribe({
        next: (data) => {
          this.columnsTitles = data.cookiesConsentTable.columnsTitles;
          this.tableInfo = data.cookiesConsentTable.info;
        }
      });
  }

  @ObservableCacheDecorator<CookiesConsentTableData>()
  public fetchCookiesTableData(): Observable<CookiesConsentTableData> {
    const cookiesConsentUrl = this.getCookiesConsentTableUrl();
    if (!cookiesConsentUrl) return;
    return this.http.get<APIResponse<CookiesConsentTableData>>(cookiesConsentUrl).pipe(
      map((response: APIResponse<CookiesConsentTableData>) => response.payload),
      catchError((error) => {
        this.sentryService.captureException(error, {
          domain: 'Cookies Consent Table',
          severity: 'info'
        });
        return [];
      })
    );
  }

  private setMetaTags(): void {
    const options: SeoOptions = { title: this.activatedRoute.snapshot.data.breadcrumbName, url: this.router.url };
    this.seoService.setTags(options);
  }
}
